module.exports = __webpack_public_path__ + "img/Group-32716-1-1.fde0a952.png";